import HttpRequest from './HttpRequest';

// Root API class. Domain APIs (AuthAPI, AppointmentsAPI) extend this so they
// share the same HttpRequest plumbing — same pattern as stratum-analytical.
class BaseAPI extends HttpRequest {
  constructor(uri) {
    super(uri, { contentType: 'application/json' });
  }
}

export const BaseService = new BaseAPI('');
export default BaseAPI;
